const GROUPS = ["부서", "사업장", "구분", "직종"];
const UNASSIGNED = "미등록";

const readObject = (value) => {
  if (!value) return {};
  if (typeof value === "object") return value;
  try {
    return JSON.parse(value) || {};
  } catch (error) {
    return {};
  }
};

const readDate = (value) => {
  const date = String(value || "").trim().slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(date) ? date : "";
};

// 433 목록과 동일하게 문서 본문을 사용한다. 연결된 employees의 값은 사용하지 않는다.
export function normalizeEmployeeDocument(post) {
  const body = readObject(post.post_content).body || {};
  const meta = readObject(post.field && post.field.meta);
  const fields = body.fieldNames || body.field_names || [];
  return {
    id: String(post.id),
    department: (body.stdInfo && body.stdInfo.부서명_과) || meta.com_name || UNASSIGNED,
    fields: Array.isArray(fields) ? [...new Set(fields.filter(Boolean))] : [],
    category: body.job_category || UNASSIGNED,
    employmentType: body.employment_type || UNASSIGNED,
    hireDate: readDate(body.hire_date),
    retirementDate: readDate(body.retirement_date),
  };
}

export function uniqueEmployeeDocuments(documents) {
  return [...new Map(documents.map((document) => [String(document.id), document])).values()];
}

export function summarizeEmployeeDocuments(documents) {
  const unique = uniqueEmployeeDocuments(documents);
  const counts = {};
  GROUPS.forEach((group) => { counts[group] = new Map(); });
  const add = (group, label) => counts[group].set(label, (counts[group].get(label) || 0) + 1);
  unique.forEach((document) => {
    add("부서", document.department || UNASSIGNED);
    add("구분", document.category || UNASSIGNED);
    add("직종", document.employmentType || UNASSIGNED);
    // 사업장별 소속 인원은 각각 표시하되 전체·부서 인원은 문서당 한 번만 센다.
    const fields = [...new Set((document.fields || []).filter(Boolean))];
    (fields.length ? fields : [UNASSIGNED]).forEach((field) => add("사업장", field));
  });
  const summary = { total: unique.length };
  GROUPS.forEach((group) => {
    summary[group] = [...counts[group]].map(([label, value]) => ({ label, value }));
  });
  return summary;
}

export function workedDuring(document, start, end) {
  const { hireDate, retirementDate } = document;
  if (start > end) return false;
  if (hireDate && retirementDate && hireDate >= retirementDate) return false;
  // 433의 계약 종료 조건(퇴임일 <= 기준일)에 맞춰 퇴임일 당일은 제외한다.
  return (!hireDate || hireDate <= end) && (!retirementDate || retirementDate > start);
}

export function buildEmployeeYearStatistics(documents, activeDocuments, year, now = new Date()) {
  const selectedYear = Number(year);
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;
  const today = `${currentYear}-${String(currentMonth).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
  const unique = uniqueEmployeeDocuments(documents);
  const data = { 월별: Array(13).fill(0) };
  GROUPS.forEach((group) => { data[group] = Array.from({ length: 13 }, () => []); });
  const assign = (index, records) => {
    const summary = summarizeEmployeeDocuments(records);
    data.월별[index] = summary.total;
    GROUPS.forEach((group) => { data[group][index] = summary[group]; });
  };

  if (selectedYear > currentYear) return data;
  const yearEnd = selectedYear === currentYear ? today : `${selectedYear}-12-31`;
  assign(0, unique.filter((document) => workedDuring(document, `${selectedYear}-01-01`, yearEnd)));

  for (let month = 1; month <= 12; month++) {
    if (selectedYear === currentYear && month > currentMonth) break;
    if (selectedYear === currentYear && month === currentMonth) {
      // 현재 월은 날짜를 재판정하지 않고 433의 '계약 중' API 응답을 그대로 집계한다.
      assign(month, activeDocuments);
    } else {
      const prefix = `${selectedYear}-${String(month).padStart(2, "0")}`;
      const end = `${prefix}-${new Date(selectedYear, month, 0).getDate()}`;
      assign(month, unique.filter((document) => workedDuring(document, `${prefix}-01`, end)));
    }
  }
  return data;
}
